import React from "react";
import { Modal, Button } from "react-bootstrap";

// Send-time guard modal. Fires only when the recipient pool
// contains un-vetted or bad-verdict recipients — admins doing all-clear
// sends (zero unvetted, zero bad) never see this modal, so it doesn't
// decay into a muscle-memory click-through.
//
// Binary choice: [Go back to review] or [Send anyway]. No "vet inline"
// button — the lifecycle complexity (modal stays open while batches
// return? re-fires Send when done?) isn't worth the click savings.
// Admins who want to vet first close this modal and click the Vet
// button on the RecipientSummary toolbar.
export default function SendGuardModal({ show, onCancel, onSendAnyway, unvettedCount, badCount, totalCount }) {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title className="h5">Some recipients flagged</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {badCount > 0 && (
          <p className="mb-2">
            <strong>{badCount}</strong> recipient{badCount === 1 ? "" : "s"} flagged as <em>bad</em> fit by AI vet.
          </p>
        )}
        {unvettedCount > 0 && (
          <p className="mb-2">
            <strong>{unvettedCount}</strong> recipient{unvettedCount === 1 ? "" : "s"} not yet vetted by AI.
          </p>
        )}
        <p className="mb-0">
          Send to all <strong>{totalCount}</strong> anyway?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancel}>
          Go back to review
        </Button>
        <Button variant="primary" onClick={onSendAnyway}>
          Send {totalCount}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
